<template>
  <BasePageContainer>
    <SettingHeader>ノートテンプレートの管理</SettingHeader>
    <div class="pt-10 pb-4">
      <NoteTemplateForm
        v-if="initialized"
        :note-template="noteTemplate"
        :department-options="allDepartments"
        :response-errors="responseErrors"
        @submit="submit" />
    </div>
  </BasePageContainer>
</template>

<script>
import SettingHeader from '@/components/parts/SettingHeader.vue'
import NoteTemplateForm from '@/components/view/note_templates/NoteTemplateForm.vue'
import allDepartments from '@/components/mixin/allDepartments'

export default {
  name: 'NoteTemplateEdit',
  components: {
    SettingHeader,
    NoteTemplateForm
  },
  mixins: [allDepartments],
  data() {
    return {
      noteTemplate: null,
      responseErrors: {},
      initialized: false
    }
  },
  computed: {
    noteTemplateId() {
      return this.$route.params.noteTemplateId
    }
  },
  async created() {
    this.$store.commit('startLoading')
    // 担当外のグループが設定されたテンプレートも編集できるよう選択肢は全グループ
    const [, fetchedDepartments] = await Promise.all([this.fetchNoteTemplate(), this.fetchAllDepartments()])
    this.$store.commit('finishLoading')
    // 選択肢が空のままだと設定済みのグループ名すら表示できないため一覧へ戻す
    if (!fetchedDepartments) {
      this.$router.push('/admin/note_templates/')
      return
    }
    // 両方揃ってから描画する（先に揃った方だけで描画すると選択中のグループ名が空欄になる）
    this.initialized = !!this.noteTemplate
  },
  methods: {
    fetchNoteTemplate() {
      return this.$axios.get(`/note_templates/${this.noteTemplateId}/`)
        .then(res => {
          this.noteTemplate = res.data
        })
        .catch(() => {
          this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
          this.$router.push('/admin/note_templates/')
        })
    },
    async submit(body) {
      this.$store.commit('startLoading')
      await this.$axios.patch(`/note_templates/${this.noteTemplateId}/`, body).then(res => {
        this.$store.commit('notify/set', { message: `${res.data.name}を保存しました。` })
        this.$router.push('/admin/note_templates/')
      }).catch(e => {
        console.error(e)
        this.responseErrors = e.response?.data || {}
        this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
      })
      this.$store.commit('finishLoading')
    }
  }
}
</script>

<style scoped>
</style>
